import { FC, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import { useTheme } from '@emotion/react';

export const Confetti: FC = () => {
  const theme = useTheme();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const colors = [theme.color.primary[100], theme.color.secondary[100]];

  useEffect(() => {
    if (!canvasRef.current) return;

    const timeout = setTimeout(() => {
      if (!canvasRef.current) return;

      const instance = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true,
      });

      instance({
        particleCount: 80,
        startVelocity: 30,
        spread: 90,
        origin: { y: 1 },
        colors,
      });
    }, 1000);

    return () => clearTimeout(timeout);
  }, [canvasRef.current]);

  return <canvas ref={canvasRef} />;
};
